import { Component, OnInit, Input} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'fury-analytics-details',
  templateUrl: './analytics-details.component.html',
  styleUrls: ['./analytics-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class AnalyticsDetailsComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input()
  allPageVisitColumns = [
    {name: 'Create dAt', property: 'createdAt', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'State', property: 'state', visible: true},
    {name: 'Country', property: 'country', visible: true},
    {name: 'Browser', property: 'browserInfo', visible: true},
    {name: 'Os Info', property: 'osInfo', visible: true},
    {name: 'Ip Address', property: 'ipAddress', visible: true},
    {name: 'Utm Source', property: 'utmSource', visible: true},
    {name: 'Internal Url', property: 'internalUrl', visible: true},
    {name: 'Referral Url', property: 'referralUrl', visible: true},
  ];
  @Input()
  pageVisitCountColumns = [
    {name: 'Internal Url', property: 'internalUrl', visible: true},
    {name: 'Page Visits', property: 'pageVisits', visible: true},
  ];
  @Input()
  soldLeadColumns = [
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Email Address', property: 'emailAddress', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'Sold Amount', property: 'soldAmount', visible: true},
    {name: 'Attempts', property: 'attempts', visible: true},
    {name: 'Address', property: 'address', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'Zip', property: 'zip', visible: true},
    {name: 'Action', property: 'action', visible: true},
  ];
  @Input()
  firstVisitDateTimeColumns = [
    {name: 'Created At', property: 'createdAt', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'State', property: 'state', visible: true},
    {name: 'Country', property: 'country', visible: true},
    {name: 'Browser', property: 'browserInfo', visible: true},
    {name: 'Os Info', property: 'osInfo', visible: true},
    {name: 'Ip Address', property: 'ipAddress', visible: true},
    {name: 'Utm Source', property: 'utmSource', visible: true},
    {name: 'Internal Url', property: 'internalUrl', visible: true},
    {name: 'Referral Url', property: 'referralUrl', visible: true},
  ];
  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:string = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
  endDate:string = moment(this.today).format('YYYY-MM-DD HH:mm:ss');
  campaignOne = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  sessionId:any;
  loader!: boolean;
  analyticDetails : any;
  allPageVisits: any;
  userDetails: any;
  tabName : string = 'totalLeads';
  leadFilterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl('firstName'),
    searchType: new FormControl('contains'),
  });
  allPageFilterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl('city'),
    searchType: new FormControl('contains'),
  });
  
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
    ) {
      this.sessionId = this.activatedRoute.snapshot.params["sessionId"];
  if(this.sessionId){
   this.getAnalyticsDetails();
   this.getPageVisitCountData();
   this.getUserDetailsData();
  } 
  this.activatedRoute.queryParams.subscribe((res: any) => {
    this.tabName = res.tabName ? res.tabName : 'totalLeads';
    this.getSoldLeadData();
  });
     }

  ngOnInit(): void {
  }
  allPageVisitsPageSize = 30;
  allPageVisitsTotalCount: number = 0;
  allPageVisitsPageIndex: number = 0;
  allPageSearchKeyword !: string;
  allPageVisitShowFilter: boolean = false;
  getAnalyticsDetails(){
    this.apiService.get(`admin/analytic/get-user-all-page-visit/${this.sessionId}?startDate=${this.startDate}&endDate=${this.endDate}&page=${Number(this.allPageVisitsPageIndex) + 1}&size=${this.allPageVisitsPageSize}${this.allPageSearchKeyword ? '&keywords=' + this.allPageSearchKeyword : ''}&searchBy=${this.allPageFilterForm.value.searchBy}&searchType=${this.allPageFilterForm.value.searchType}`).subscribe((res:any)=>{
      if(res?.body){
        if(res.body?.allPageVisits?.data){
          this.allPageVisits = res.body?.allPageVisits?.data;
        this.allPageVisitsTotalCount = res.body?.allPageVisits?.total;
        } else {
          this.allPageVisits = undefined;
        }  
      }
    }, err =>{
      if(err){
        console.log(err);
      }
    })
    this.allPageVisitShowFilter = false;
  };
  onAllPageFilterChange(value: string){
    this.allPageVisitsPageIndex = 0;
    this.allPageSearchKeyword = value.trim();
    this.getAnalyticsDetails();
  };
  allPageVisitSerchByValue: FilterValue[] = [
    {title: 'City', value: 'city'},
    {title: 'State', value: 'state'},
    {title: 'Country', value: 'country'},
    {title: 'Browser Info', value: 'browserInfo'},
    {title: 'Os Info', value: 'osInfo'},
    {title: 'Ip Address', value: 'ipAddress'},
    {title: 'Utm Source', value: 'utmSource'},
    {title: 'Internal Url', value: 'internalUrl'},
    {title: 'Referral Url', value: 'referralUrl'},
  ];
  
  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getAnalyticsDetails();
    this.getPageVisitCountData();
    this.getSoldLeadData();
    this.getUserDetailsData();
  };
  pageSizeChange(event: any) {    
    this.allPageVisitsPageSize = event.pageSize;
    this.allPageVisitsPageIndex = event.pageIndex;
    this.getAnalyticsDetails();
  }
  navigateLeadDetails(leadId: string){
    this.router.navigateByUrl('/lead/lead-details/'+ leadId + '?type=customerInformation');
  };
  get visibleColumns() {
    return this.allPageVisitColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  visitCountPageSize = 30;
  visitCountTotalCount: number = 0;
  visitCountPageIndex: number = 0;
  pageVisitCountList :any;
  pageVisitCountSearchKeyword !:string;
  getPageVisitCountData(){
    this.apiService.get(`admin/analytic/get-user-page-visit-counts/${this.sessionId}?startDate=${this.startDate}&endDate=${this.endDate}&page=${Number(this.visitCountPageIndex) + 1}&size=${this.visitCountPageSize}${this.pageVisitCountSearchKeyword ? '&keywords=' + this.pageVisitCountSearchKeyword : ''}`).subscribe((res:any)=>{
      if(res?.body){
        if(res?.body?.pageVisitCounts?.data){
          this.pageVisitCountList = res?.body?.pageVisitCounts?.data;
          this.visitCountTotalCount = res?.body?.pageVisitCounts?.total;
        } else {
          this.pageVisitCountList = undefined;
        }
      }
    })
  }
  visitCountPageSizeChange(event: any) {    
    this.visitCountPageSize = event.pageSize;
    this.visitCountPageIndex = event.pageIndex;
    this.getPageVisitCountData();
  };
  visitCountFilterChange(value: string){
    this.visitCountPageIndex = 0;
    this.pageVisitCountSearchKeyword = value.trim();
    this.getPageVisitCountData();
  };
  get visitColumnVisibleColumns() {
    return this.pageVisitCountColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  soldLeadPageSize = 30;
  soldLeadTotalCount: number = 0;
  soldLeadPageIndex: number = 0;
  soldSearchedKeyword !: string;
  soldLeadList :any;
  listTitle !: string;
  leadShowFilter: boolean = false;
  getSoldLeadData(){
    this.apiService.get(`admin/analytic/get-user-tab-data/${this.sessionId}?startDate=${this.startDate}&endDate=${this.endDate}&page=${Number(this.soldLeadPageIndex) + 1}&size=${this.soldLeadPageSize}&tabName=${this.tabName}${this.soldSearchedKeyword ? '&keywords=' + this.soldSearchedKeyword : ''}&searchBy=${this.leadFilterForm.value.searchBy}&searchType=${this.leadFilterForm.value.searchType}`).subscribe((res:any)=>{  
      if(res?.body){
        this.listTitle = res.body?.listTitle;
        if(res?.body?.data?.data){
          this.soldLeadList = res?.body?.data?.data;
          this.soldLeadTotalCount = res?.body?.data?.total;   
        } else {
          this.soldLeadList = undefined;
        }
      }
    })
  };
  leadSerchByValue: FilterValue[] = [
    {title: 'First Name', value: 'firstName'},
    {title: 'Last Name', value: 'lastName'},
    {title: 'Email Address', value: 'emailAddress'},
    {title: 'Source', value: 'source'},
    {title: 'Address', value: 'address'},
    {title: 'City', value: 'city'},
    {title: 'Zip', value: 'zip'},
  ];
  onSoldFilterFilterChange(value: any) {    
    this.soldLeadPageIndex = 0;
    this.soldSearchedKeyword = value.trim();
    this.getSoldLeadData();
};
  soldLeadPageSizeChange(event: any) {    
    this.soldLeadPageSize = event.pageSize;
    this.soldLeadPageIndex = event.pageIndex;
    this.getSoldLeadData();
  };
  soldFilterChange(){
    this.getSoldLeadData();
    this.leadShowFilter = false;
  }
  get soldLeadVisibleColumns() {
    return this.soldLeadColumns
      .filter((column) => column.visible)
      .map((column) => column.property);
  };
  firstVisitDateTimeList: any = [];
  firstOriginalVisitLeadSourceData: any;
  getUserDetailsData(){
    let firstdata: any[];
    this.apiService.get(`admin/analytic/get-user-detail-data/${this.sessionId}?startDate=${this.startDate}&endDate=${this.endDate}&page=1&size=30`).subscribe((res: any)=>{
      if(res?.body){
        this.userDetails = res.body;
        this.firstVisitDateTimeList = res.body?.firstOriginalVisitDateTimeData;
       this.firstOriginalVisitLeadSourceData = res.body?.firstOriginalVisitLeadSourceData;
      }
    })
  };
  changeTabName(tabName: string){
    this.tabName = tabName;
    this.router.navigateByUrl(`/audience/analytics-details/${this.sessionId}?tabName=${this.tabName}`)
  };
  goto(i: number) {
    setTimeout(() => {
      document.getElementById(i.toString())?.scrollIntoView(
        { behavior: 'smooth', block: 'center' })
    }, 100);
  };

}
